import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { useFormik } from 'formik';
import { toast } from "react-toastify";
import { trainingApi } from '../../services';

const UpdateTRFAssesmentView = ({ clickedRowData, reloadTrfHistory }) => {
  const [nominatedParticipant, setNominatedParticipant] = useState();
  const [tRFTrainingId, setTRFTrainingId] = useState('');

  useEffect(() => {
    setNominatedParticipant(clickedRowData?.trainingRequisitionForm?.nameOfNominatedParticipant);
    setTRFTrainingId(clickedRowData?.trainingRequisitionForm?.trainingDetails[0]?.id);
  }, []);

  const formik = useFormik({
    initialValues: {
      assesmentLink: '',
      feedbackLink: ''
    },
    validate: (data) => {
      let errors = {};
      if (clickedRowData?.trainingRequisitionForm?.trainingType === 'Instructor-Led') {
        if (!data.assesmentLink) errors.assesmentLink = 'Assesment Link is required.';
      }
      if (!data.feedbackLink) errors.feedbackLink = 'Feedback Link is required.';
      return errors;
    },
    onSubmit: (data) => {
      let params = {
        id: clickedRowData?.trainingRequisitionForm?.trainingDetails[0]?.id,
        assesment_link: data.assesmentLink,
        is_assessment: data.assesmentLink ? true : false,
        feedback_link: data.feedbackLink,
        is_feedback: data.feedbackLink ? true : false,
      }
      console.log(params, "paramsparamsparams")
      try {
        trainingApi.updateEmployeeTraining(params).then(
          (resp) => {
            toast.success(resp.data.message);
            // setUpdateAssesmentDialog(false);
            setTimeout(() => {
              reloadTrfHistory()
            }, 1000);
          },
          (err) => {
            toast.error(err.response.data.error);
          }
        );
      } catch (error) {
        toast.error("Unable to update");
      }
    },
  });

  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };


  return (
    <>
      <hr />
      <form onSubmit={formik.handleSubmit} autoComplete='off'>
        <div>
          <div className="flex flex-wrap p-field font-bold block">
            <div className="col-6">
              <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Employee Name</label>
              <div className="p-inputgroup flex-1">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-user"></i>
                </span>{" "}
                <InputText id="nominatedParticipant" disabled placeholder="Employee name" className="w-full" value={nominatedParticipant} />
              </div>
            </div>

            <div className="col-6">
              <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Training ID</label>
              <div className="p-inputgroup flex-1">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-eject"></i>
                </span>{" "}
                <InputText id="nominatedParticipant" disabled placeholder="Training ID" className="w-full" value={tRFTrainingId} />
              </div>
            </div>
          </div>
          <div className="flex flex-wrap p-field font-bold block">
            <div className="col-6">
              <label htmlFor="assesmentLink" disabled className="font-bold block mb-2 training-heading">Assesment Link</label>
              <div className="p-inputgroup flex-1">
                <InputText name="assesmentLink" placeholder="Assesment Link" className="w-full" value={formik.values.assesmentLink} onChange={formik.handleChange} disabled={clickedRowData?.trainingRequisitionForm?.trainingType === 'Instructor-Led' ? false : true} />
              </div>
              {getFormErrorMessage('assesmentLink')}
            </div>
            <div className="col-6">
              <label htmlFor="feedbackLink" className="font-bold block mb-2 training-heading ">Feedback Link</label>
              <InputText name="feedbackLink" placeholder="Feedback Link" className="w-full" value={formik.values.feedbackLink} onChange={formik.handleChange} />
              {getFormErrorMessage('feedbackLink')}
            </div>
          </div>
        </div>
        <hr />
        <div className='' style={{ textAlign: 'right' }}>
          <Button label='Update' icon='pi pi-check' severity='primary' className='mr-1' />
          {/* <Button label='Cancel' type='button' icon='pi pi-times' severity='secondary' onClick={() => setUpdateAssesmentDialog(false)} /> */}
        </div>
      </form>
    </>
  )
}
export default UpdateTRFAssesmentView;
